import { CSSObject, DefaultTheme } from "styled-components";
import { useTheme } from "../../../assets/theme/ThemeProvider";

interface TagInputStyles {
    badge: CSSObject;
    close: CSSObject;
}

const useTagInputStyles = (): TagInputStyles => {
    const theme: DefaultTheme = useTheme();
    return {
        badge: {
            color: "#495057",
            fontSize: "1rem",
            fontWeight: "normal",
            border: "0.15rem solid #ECEDED",
        },
        close: {
            cursor: "pointer",
            marginLeft: "0.25rem",
            fontSize: "1.2rem",
        }
    };
};

export default useTagInputStyles;